import React from 'react';

class Report extends React.Component {

    getReportViewer = () => 

        fetch(
            process.env.REACT_APP_API_HOST + 'api/reports/demo',
            {   
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/pdf'
                },
                responseType: 'blob'
            })
            .then(res => res.blob())
            .then(data => 
                
                {
                
                //Build a URL from the file
                const fileURL = URL.createObjectURL(data);
                //Open the URL on new Window
                window.open(fileURL);
            });

   
    render() {
        this.getReportViewer()
        return;
    }
}

export default Report;